import React, { useState } from 'react';
import Slider from 'react-rangeslider';
import { FormattedNumber } from 'react-intl';
import 'react-rangeslider/lib/index.css';
import './rangeslider.css';

interface Props {
  InstalmentMinValue: number;
  InstalmentMaxValue: number;
  setInstalmentValue: any;
  InstalmentValue: number;
  errormsg: Function;
  setIsEditedValue?: any;
}
const RangeSlider = ({
  InstalmentMinValue,
  InstalmentMaxValue,
  InstalmentValue,
  setInstalmentValue,
  errormsg,
  setIsEditedValue,
}: Props) => {
  const handleChange = (value: number) => {
    let selectedValue = Math.round(value);
    let min = (InstalmentMinValue / 100);
    let max = (InstalmentMaxValue / 100);
    if (selectedValue < min) selectedValue = min;
    if (selectedValue > max || selectedValue === Math.round(max)) selectedValue = max;
    if (selectedValue > 0 && setIsEditedValue != undefined) {
      setIsEditedValue(false);
    }
    setInstalmentValue(selectedValue);
    errormsg(false);
  };

  return (
    <div className="RangeSliderwrapper">
      <Slider
        min={InstalmentMinValue / 100}
        max={InstalmentMaxValue / 100}
        value={InstalmentValue}
        onChange={(value) => handleChange(value)}
        tooltip={false}
      />
    </div>
  );
};

export default RangeSlider;
